import store from "@/vuex/store";

import _ from "lodash";
export function branchingLogic(nextQuestionId, question) {
  const quesObj = _.find(question, ["id", nextQuestionId]);
  if (quesObj && quesObj.hasOwnProperty("stepSequence")) {
    if (quesObj.type === "SurveyCompletion") {
      return "End Activity";
    } else {
      return `Skip to step ${quesObj.stepSequence}`;
    }
  }
}
export function branchingLogicRecursive(nextQuestionId, question) {
  const findObjText = _.find(question, ["id", nextQuestionId]);
  if (findObjText && findObjText.hasOwnProperty("stepSequence")) {
    if (findObjText.type === "SurveyCompletion") {
      return "End activity";
    } else {
      const ordertext = findObjText.stepSequence < question.stepSequence ? "Back" : "Skip";
      return `${ordertext} to step ${findObjText.stepSequence}`;
    }
  } else {
    return "No logic";
  }
}

export function isSiteUser(userRole) {
  let siteUserRoles = ["Pi", "SubPi", "SiteDataLock", "StudyCoordinator", "HomeHealth", "Rater", "CallCenter"];
  if (siteUserRoles.includes(userRole)) {
    return true;
  } else {
    return false;
  }
}

export function setSiteId() {
  store.dispatch("saveSelectedSiteId", localStorage.getItem("selectedSite"));
}

export function filterArchiveList(archive) {
  if (archive && archive.length > 0) {
    archive = archive.filter(a => {
      return a.s3objectKey != undefined;
    });
    if (archive.length > 1) {
      archive.sort((objA, objB) => Number(objB.endTime) - Number(objA.endTime));
    }
    return archive;
  }
}

export function videoRecordingcalcluation(videorecordlength) {
  videorecordlength.addEventListener("loadedmetadata", async () => {
    const videoduration = videorecordlength.duration;
    const time = await formatTime(Math.round(videoduration));
    document.getElementById("duration").innerHTML = time;
  });
}

export function formatTime(timeInSeconds) {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60);
  const seconds = timeInSeconds % 60;
  let formattedTime = "";
  if (hours > 0) {
    formattedTime += hours.toString().padStart(2, "0") + ":";
  }
  formattedTime += minutes.toString().padStart(2, "0") + ":";
  formattedTime += seconds.toString().padStart(2, "0");

  return formattedTime;
}
